import { useState, useEffect } from 'react';

const MODAL_DISMISSED_KEY = 'cosmo_app_modal_dismissed';
const MODAL_DISMISSED_EXPIRY = 24 * 60 * 60 * 1000; // 24 horas em millisegundos

export const useAppModalState = () => {
  const [shouldShowModal, setShouldShowModal] = useState(false);

  useEffect(() => {
    const checkShouldShowModal = () => {
      try {
        const dismissedData = localStorage.getItem(MODAL_DISMISSED_KEY);
        
        if (dismissedData) {
          const { timestamp } = JSON.parse(dismissedData);
          const now = Date.now();
          
          // Se passou mais de 24 horas, mostra o modal novamente
          if (now - timestamp > MODAL_DISMISSED_EXPIRY) {
            localStorage.removeItem(MODAL_DISMISSED_KEY);
            return true;
          }
          
          return false; // Modal foi dispensado recentemente
        }
        
        return true; // Primeira vez, mostra o modal
      } catch (error) {
        console.error('Erro ao verificar estado do modal:', error);
        return true;
      }
    };

    setShouldShowModal(checkShouldShowModal());
  }, []);

  const dismissModal = () => {
    try {
      const dismissData = {
        timestamp: Date.now()
      };
      localStorage.setItem(MODAL_DISMISSED_KEY, JSON.stringify(dismissData));
      setShouldShowModal(false);
    } catch (error) {
      console.error('Erro ao salvar dismissal do modal:', error);
      setShouldShowModal(false);
    }
  };

  return {
    shouldShowModal,
    dismissModal
  };
};
